if (!customElements.get('delivery-estimator')) {
  customElements.define(
    'delivery-estimator',
    class DeliveryEstimator extends HTMLElement {
      connectedCallback() {
        try {
          this.textElement = this.querySelector('.delivery-estimator__text');
          if (!this.textElement || this.hidden) return;
          this.renderClientEstimate();
        } catch (error) {
          console.error('[delivery-estimator]', error);
        }
      }

      getLocalTime() {
        const tz = this.dataset.timezone || 'Europe/Berlin';
        const now = new Date();
        try {
          const parts = new Intl.DateTimeFormat('de-DE', {
            timeZone: tz,
            hour: 'numeric',
            weekday: 'long',
            hour12: false,
          }).formatToParts(now);
          const hour = parseInt(parts.find((p) => p.type === 'hour')?.value ?? '0', 10);
          const dayName = parts.find((p) => p.type === 'weekday')?.value ?? '';
          const dayMap = {
            Montag: 1,
            Dienstag: 2,
            Mittwoch: 3,
            Donnerstag: 4,
            Freitag: 5,
            Samstag: 6,
            Sonntag: 0,
          };
          return { hour, weekday: dayMap[dayName] ?? now.getDay() };
        } catch {
          return { hour: now.getHours(), weekday: now.getDay() };
        }
      }

      easterSunday(year) {
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
        return [month, day];
      }

      germanHolidays(year) {
        const [em, ed] = this.easterSunday(year);
        const easter = new Date(year, em - 1, ed);

        const offset = (days) => {
          const d = new Date(easter);
          d.setDate(d.getDate() + days);
          return `${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        };

        return new Set([
          '01-01',
          '05-01',
          '10-03',
          '12-25',
          '12-26',
          offset(-2),
          offset(1),
          offset(39),
          offset(50),
        ]);
      }

      isHolidayOrWeekend(date) {
        const dow = date.getDay();
        if (dow === 0 || dow === 6) return true;
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const holidays = this.germanHolidays(date.getFullYear());
        return holidays.has(`${mm}-${dd}`);
      }

      addBusinessDays(date, n) {
        const d = new Date(date);
        let added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (!this.isHolidayOrWeekend(d)) added++;
        }
        return d;
      }

      formatDate(date) {
        return new Intl.DateTimeFormat('de-DE', {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        }).format(date);
      }

      applyTemplate(template, range) {
        return String(template || '').replace('{{ range }}', range);
      }

      renderClientEstimate() {
        const { hour } = this.getLocalTime();
        const cutoff = Number(this.dataset.cutoffHour || 14);
        const late = hour >= cutoff;
        const mode = this.dataset.mode || 'full';
        const now = new Date();

        let dispatch = new Date(now);
        const dispatchedToday = !late && !this.isHolidayOrWeekend(dispatch);
        if (!dispatchedToday) {
          dispatch = this.addBusinessDays(dispatch, 1);
        }

        const earliest = this.addBusinessDays(dispatch, 1);
        const latest = this.addBusinessDays(dispatch, 2);
        const earliestStr = this.formatDate(earliest);
        const latestStr = this.formatDate(latest);
        const sameDay = earliest.toDateString() === latest.toDateString();
        const range = sameDay ? earliestStr : `${earliestStr} - ${latestStr}`;
        const template =
          mode === 'badge'
            ? this.dataset.serverBadgeLabel || 'Lieferung: {{ range }}'
            : this.dataset.serverLabel || 'Heute bestellt, Lieferung: {{ range }}';

        this.textElement.textContent = this.applyTemplate(template, range);
      }
    }
  );
}
